import { memo } from "react";

type UserLayoutProps = {
  children: React.ReactNode;
};

export default memo(({ children }: UserLayoutProps) => {
  return <div>{children}</div>;
});
